import type { CSSProperties, FC } from 'react';

interface StopSelectionPopupContentProps {
    onSelectFrom: () => void;
    onSelectTo: () => void;
    isFromActive?: boolean;
    isToActive?: boolean;
}

const getButtonStyle = (active: boolean): CSSProperties => ({
    padding: '6px 10px',
    borderRadius: 4,
    border: `1px solid ${active ? '#173fb5' : '#c9d3e0'}`,
    backgroundColor: active ? '#173fb5' : '#ffffff',
    color: active ? '#ffffff' : '#173fb5',
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
});

const StopSelectionPopupContent: FC<StopSelectionPopupContentProps> = ({
    onSelectFrom,
    onSelectTo,
    isFromActive = false,
    isToActive = false,
}) => (
    <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
        <button type="button" style={getButtonStyle(isFromActive)} onClick={onSelectFrom}>
            From
        </button>
        <button type="button" style={getButtonStyle(isToActive)} onClick={onSelectTo}>
            To
        </button>
    </div>
);

export default StopSelectionPopupContent;
